import l from "../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import * as t from "react";
import { createPortal as q } from "react-dom";
import a from "../../../rc-util/es/Dom/canUseDom.mjs";
import x from "../../../rc-util/es/warning.mjs";
import { supportRef as F, useComposeRef as M } from "../../../rc-util/es/ref.mjs";
import T from "./Context.mjs";
import U from "./useDom.mjs";
import j from "./useScrollLocker.mjs";
import { inlineMock as z } from "./mock.mjs";
var N = function(o) {
  return o === !1 ? !1 : !a() || !o ? null : typeof o == "string" ? document.querySelector(o) : typeof o == "function" ? o() : o;
}, A = /* @__PURE__ */ t.forwardRef(function(o, f) {
  var r = o.open, S = o.autoLock, m = o.getContainer, R = o.debug, s = o.autoDestroy, c = s === void 0 ? !0 : s, e = o.children, g = t.useState(r), p = l(g, 2), h = p[0], k = p[1], d = h || r;
  process.env.NODE_ENV !== "production" && x(a() || !r, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), t.useEffect(function() {
    (c || r) && k(r);
  }, [r, c]);
  var w = t.useState(function() {
    return N(m);
  }), v = l(w, 2), i = v[0], D = v[1];
  t.useEffect(function() {
    var V = N(m);
    D(V ?? null);
  });
  var b = U(d && !i, R), E = l(b, 2), y = E[0], C = E[1], n = i ?? y;
  j(S && r && a() && (n === y || n === document.body));
  var P = null;
  if (e && F(e) && f) {
    var _ = e;
    P = _.ref;
  }
  var L = M(P, f);
  if (!d || !a() || i === void 0)
    return null;
  var O = n === !1 || z(), u = e;
  return f && (u = /* @__PURE__ */ t.cloneElement(e, {
    ref: L
  })), /* @__PURE__ */ t.createElement(T.Provider, {
    value: C
  }, O ? u : /* @__PURE__ */ q(u, n));
});
process.env.NODE_ENV !== "production" && (A.displayName = "Portal");
export {
  A as default
};
//# sourceMappingURL=Portal.mjs.map
